import { defineMessages } from 'react-intl'

export default defineMessages({
  'Password': {
    id: 'hfty.soiljobs.password',
    defaultMessage: 'Password',
  },
  'cannotEditJob': {
    id: 'cannotEditJob',
    defaultMessage: 'Sorry, this job cannot be edited because its status is already in ',
    description: 'Job cant be edited because status is Shipping or Results Posted (appended in component)',
  },
})
